import { Component } from '@verndale/core';

class PageTabs extends Component {
  constructor(el, options) {
    super(el, options);

    this.initTabs();
  }

  setupDefaults() {
    this.dom = {
      scrollbody: document.querySelector('#content'),
      box: this.el.querySelector('.transtion-left-right-wrap'),
      tabLinks: [...this.el.querySelectorAll('.tabs-title a')],
      tabPanels: [...this.el.querySelectorAll('.tabs-panel')],
      mobileContainer: this.el.querySelector('.mobile-subnav')
    };
    this.breakpoint = window.matchMedia('(max-width: 639px)');
    this.isMobileOpen = false;
    this.selectedPanel = null;

    this.createMobileDropdown();
  }

  addListeners() {
    this.dom.tabLinks.forEach(tab =>
      tab.addEventListener('click', this.handleTabClick.bind(this))
    );
    this.dom.dropdownButton.addEventListener(
      'click',
      this.toggleDropdown.bind(this)
    );
    this.dom.mobileLinks.forEach(item =>
      item.addEventListener('click', this.handleDropdownChange.bind(this))
    );
    this.breakpoint.addEventListener(
      'change',
      this.handleMobilePanel.bind(this)
    );

    
    this.dom.scrollbody.addEventListener('scroll', this.lazyload.bind(this));
  }

  initTabs() {
    this.selectTab(this.dom.tabLinks[0]);
    this.selectMobileTab(this.dom.mobileLinks[0]);
  }

  createMobileDropdown() {
    if (!this.dom.mobileContainer) return;

    const dropdownTemplate = `
      <li role="tab">
        <a class="toggle-mobile-subnav"></a>
        <ul class="menu vertical nested submenu is-active" role="tabpanel" hidden>
          ${[...this.dom.tabLinks]
            .map(
              tab =>
                `<li class="tabs-title is-submenu-item">
                <a href="${tab.getAttribute('href')}">${tab.innerText}</a>
                </li>`
            )
            .join('')}
        </ul>
      </li>
      `;
    this.dom.mobileContainer.innerHTML = dropdownTemplate;
    this.dom.dropdownList = this.dom.mobileContainer.querySelector('.submenu');
    this.dom.dropdownButton = this.dom.mobileContainer.querySelector(
      '.toggle-mobile-subnav'
    );
    this.dom.mobileLinks = [
      ...this.dom.mobileContainer.querySelectorAll('.is-submenu-item a')
    ];
  }

  handleTabClick(e) {
    e.preventDefault();
    this.selectTab(e.target, true);

    // Update mobile tabs
    const selectedTab = this.dom.mobileLinks.find(
      tab => tab.href === e.target.href
    );
    this.selectMobileTab(selectedTab);
  }

  handleDropdownChange(e) {
    e.preventDefault();
    e.stopPropagation();

    const target = e.currentTarget;
    this.selectMobileTab(target);

    // Update desktop tabs
    const selectedTab = this.dom.tabLinks.find(tab => tab.href === target.href);
    this.selectTab(selectedTab);
  }

  selectTab(link) {
    this.setActiveTab(link);
  }

  selectMobileTab(selectedTab) {
    this.dom.dropdownButton.innerText = selectedTab.innerText.trim();

    this.dom.mobileLinks.forEach(item => {
      if (item === selectedTab) {
        item.setAttribute('aria-selected', true);
        item.style.display = 'none';
      } else {
        item.setAttribute('aria-selected', false);
        item.style.display = 'block';
      }
    });

    if (this.isMobileOpen) {
      this.toggleDropdown();
    }
  }

  setActiveTab(selectedTab) {
    this.dom.tabLinks.forEach(tab => {
      if (tab === selectedTab) {
        tab.parentNode.classList.add('is-active');
      } else {
        tab.parentNode.classList.remove('is-active');
      }
    });

    this.dom.tabPanels.forEach(panel => {
      if (
        panel.id === selectedTab.getAttribute('href').replace('#', '').trim()
      ) {
        this.selectedPanel = panel;
        panel.style.display = 'block';
      } else {
        panel.style.display = 'none';
      }
    });

    this.selectedTabId = selectedTab.getAttribute('href');
    this.handleMobilePanel();

    this.lazyload();
  }

  handleMobilePanel() {
    if (this.breakpoint.matches) {
      this.el.dispatchEvent(
        new Event(
          this.selectedTabId === '#overview' ? 'closePanel' : 'openPanel',
          {
            bubbles: true,
            detail: {
              selectedTabId: this.selectedTabId
            }
          }
        )
      );
    }
  }

  toggleDropdown() {
    this.isMobileOpen = !this.isMobileOpen;
    if (this.isMobileOpen) {
      this.dom.dropdownList.removeAttribute('hidden');
    } else {
      this.dom.dropdownList.setAttribute('hidden', true);
    }
  }

  lazyload() {
    const offset = 150;
    const lazyload = [
      ...this.selectedPanel.querySelectorAll('.article-lazyload')
    ];
    if (lazyload.length === 0) return;

    lazyload.forEach(item => {
      if (item.getBoundingClientRect().top < window.innerHeight - offset) {
        item.classList.add('article-lazyload--revealed');
      }
    });
  }
}

export default PageTabs;
